import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	daysInColumn: {
		id: 'card.common.days-in-column.days-in-column',
		defaultMessage: '{days, plural, one {# day} other {# days}} in this column',
		description: 'Tooltip for card days in column in Jira Software boards',
	},
});
